module.exports = __webpack_public_path__ + "img/aside_logo2.cdd72393.png";